import React from 'react';
import { Dispatch } from 'redux';
import { RouteComponentProps } from 'react-router';
import {
  Dimmer, Header, Loader, Grid, GridColumn, 
} from 'semantic-ui-react';
import { connect } from 'react-redux';
import { WithTranslation, withTranslation } from 'react-i18next';
import { isUndefined, toUpper } from 'lodash';
import Timer from '../../components/Timer/Timer';
import VisualTimerBar from '../../components/Timer/VisualTimerBar';
import Guidelines from '../../components/Guidelines/Guidelines';
import LiveGraphWindow from '../../components/Exercise/LiveGraph/LiveGraphExercisesWithContext';
import LiveGraphLandscape from '../../components/Exercise/LiveGraph/LiveGraphLandscape';
import { hideSideBar, showSideBar } from '../../actions/navBar.actions';
import * as sensorDataAnalysis from '../../utils/sensorDataAnalysis';
import {
  uploadActivity, handleActivityStatus, handleCurrentRepUpdate, handleTimerStatus, handleCalibrationStatus,
  addChartDataPoint, addChartDataPoints, clearChartData, updateCurrentStrength, updateElapsedTime,
} from '../../actions/activities.actions';
import './ExerciseManager.css';
import Navigation from '../../components/Exercise/Navigation/Navigation';
import { State } from '../../reducers';
import GlobalBluetoothWrapper from '../../utils/GlobalBluetoothWrapper';
import { handleBluetoothState, bluetoothConnection } from '../../actions/bluetooth.actions';
import { api } from '../../config/axiosConfig';
import Activity from '../../classes/Activity';
import { Workout, Rep } from '../../classes/Workout';
// Audio imports - these may need to be handled differently in TypeScript
// import soundHang from '../../assets/sounds/hang_sound.ogg';
// import soundRest from '../../assets/sounds/rest_sound.ogg';

import Calibration from '../../components/calibration/Calibration';
import BluetoothSetupFlowWithContext from '../../components/BluetoothSetupFlow/BluetoothSetupFlowWithContext';
import { ExerciseSetRep } from '../../components/exerciseSetRep/ExerciseSetRep';
import LiveStrengthBar from '../../components/LiveStrengthBar/LiveStrengthBar';
import { PulledWeight } from './PulledWeight/PulledWeight';
import GlobalTimer from '../../components/GlobalTimer/GlobalTimer';
// import { ResponsiveUtil } from '../../utils/ResponsiveUtil';
// import { DataTable } from './DataTable/DataTable';
// import { WeightUnit } from '../../types';
import { SensorDataProvider } from '../../contexts/SensorDataContext';
import BluetoothProvider from '../../contexts/BluetoothContext';
import WorkoutTypeSetter from '../../components/ExerciseManager/WorkoutTypeSetter';
import CalibrationDataBridge from '../../components/ExerciseManager/CalibrationDataBridge';
import BluetoothDisconnectionNotification from '../../components/BluetoothDisconnectionNotification/BluetoothDisconnectionNotification';
import { calculateForce, ForceCalculationMode } from '../../utils/ForceCalculation';
import { SimpleWorkoutManager } from '../../utils/SimpleWorkoutManager';
import { timerService } from '../../services/TimerService';
import RepFeedbackToast from '../../components/RepFeedbackToast/RepFeedbackToast';
const soundHang = require('../../assets/sounds/hang_sound.ogg');
const soundRest = require('../../assets/sounds/rest_sound.ogg');

interface ExerciseManagerProps extends RouteComponentProps<{}, {}, { workout: Workout }>, WithTranslation {
  dispatch: Dispatch<any>
  uploadedId: number
  activityStatus: string
  timerStatus: string
  calibrationStatus: string
  bluetoothConnected: boolean
  currentRep: Rep
  weightUnit: string
  currentStrength: number | 'MAX' | 'Out'
  bluetoothStatus: string
  chartDataArray: { x: number; y: number }[]
  elapsedTime: number
}
interface ExerciseManagerState {
  activity: Activity
  guidelineRep: Rep
  nextGuidelineRep: any
  calibrateReady: boolean
  done: boolean
  mobile: boolean
  landscape: boolean
  orientation: boolean
  calibrationData: Array<number>
  bluetoothConnected: boolean
  bluetoothCalibrated: boolean
  showDisconnectionNotification: boolean
  repFeedback: 'success' | 'fail' | 'too_much' | null
}
const mapStateToProps = (state: State) => ({
  uploadedId: state.activities.uploadedId,
  activityStatus: state.activities.activityStatus,
  timerStatus: state.activities.timerStatus,
  calibrationStatus: state.activities.calibrationStatus,
  currentRep: state.activities.currentRep,
  bluetoothConnected: state.bluetooth.bluetoothConnected,
  weightUnit: state.authentication.user.displaySettings.weightUnit,
  currentStrength: state.activities.currentStrength,
  bluetoothStatus: state.bluetooth.bluetoothStatus,
  chartDataArray: state.activities.chartData,
  elapsedTime: state.activities.elapsedTime,
});
// let weightUnitFactor; // Removed unused variable

// #region Inital state
// #endregion
class ExerciseManager extends React.Component<ExerciseManagerProps, ExerciseManagerState> {
  
  // #region Constructor
  private managerActivity: Activity;

  private activityType: any;

  private audioHang: any;

  private audioRest: any;
  private pulledWeight1: number;
  private needsLoadBeforePull: boolean = false;
  private waitReleaseStartTime: number | null = null;
  private repStartWallTime: number = 0;
  private lastDisplayUpdateTime: number = 0;
  private static readonly DISPLAY_INTERVAL_MS = 50; // throttle Redux display dispatches to ~20 Hz
  private chartPointBuffer: { x: number; y: number }[] = [];
  private globalBluetoothWrapper: GlobalBluetoothWrapper;
  private isUpdatingBluetoothState: boolean = false;
  private workoutManager: SimpleWorkoutManager;
  private unsubscribeDataStream: (() => void) | null = null;

  

  constructor(props: ExerciseManagerProps) {
    super(props);
    this.activityType = {
      title: this.props.t(this.props.location.state.workout.title),
      type: this.props.location.state.workout.subtype,
      selectedWorkout: this.props.location.state.workout.type,
      notes: '',
    };
    this.audioHang = new Audio(soundHang);
    this.audioRest = new Audio(soundRest);

    this.managerActivity = new Activity(this.activityType, this.props.location.state.workout);

    this.pulledWeight1 =0;
    this.globalBluetoothWrapper = GlobalBluetoothWrapper.getInstance();
    this.workoutManager = SimpleWorkoutManager.getInstance();
    
    timerService.initialize(this.props.dispatch);
    this.props.dispatch(handleCurrentRepUpdate(this.managerActivity.currentRep));
    this.state = {
      activity: this.managerActivity,
      guidelineRep: this.managerActivity.currentRep || new Rep(),
      nextGuidelineRep: null,
      done: false,
      mobile: false,
      landscape: false,
      orientation: false,
      calibrateReady: false,
      calibrationData: [],
      bluetoothConnected: false,
      bluetoothCalibrated: false,
      showDisconnectionNotification: false,
      repFeedback: null,
    };

    this.getDetailJsonWorkout();
    this.fetchUserStats();
    
    // Expose debug methods to window for console debugging
    (window as any).exerciseManager = this;
    
    // Add comprehensive debugging tools
    (window as any).debugWorkout = {
      // Get current state
      getState: () => ({
        activityStatus: this.props.activityStatus,
        timerStatus: this.props.timerStatus,
        bluetoothConnected: this.state.bluetoothConnected,
        bluetoothCalibrated: this.state.bluetoothCalibrated,
        workoutManagerState: this.workoutManager.getState(),
        currentRep: this.workoutManager.getCurrentRep(),
        guidelineRep: this.state.guidelineRep,
        nextGuidelineRep: this.state.nextGuidelineRep,
        elapsedTime: this.props.elapsedTime,
        liveGraphData: this.state.activity.liveGraphData,
        liveGraphDataArray: this.state.activity.liveGraphDataArray
      }),
      
      // Get workout manager state
      getWorkoutManagerState: () => this.workoutManager.getState(),
      
      // Check if workout manager is initialized
      isWorkoutManagerInitialized: () => this.workoutManager.isInitialized(),
      
      // Get current rep info
      getCurrentRep: () => this.workoutManager.getCurrentRep(),
      
      // Get next rep info
      getNextRep: () => this.workoutManager.getNextRep(),
      
      // Force state transitions (for debugging)
      forceActivityStatus: (status: string) => {
        console.log('🔧 Force setting activity status to:', status);
        this.props.dispatch(handleActivityStatus(status));
      },
      
      // Force timer status
      forceTimerStatus: (status: string) => {
        console.log('🔧 Force setting timer status to:', status);
        this.props.dispatch(handleTimerStatus(status));
      },
      
      // Initialize workout manager manually
      initializeWorkoutManager: () => {
        console.log('🔧 Manually initializing workout manager');
        this.initializeWorkoutManager();
      },
      
      // Start workout manually
      startWorkout: () => {
        console.log('🚀 Manually starting workout');
        if (this.workoutManager.isInitialized()) {
          this.workoutManager.startWorkout();
        } else {
          console.error('❌ Workout manager not initialized');
        }
      },
      
      // Start get ready countdown
      startGetReady: () => {
        console.log('⏰ Manually starting get ready countdown');
        if (this.workoutManager.isInitialized()) {
          this.workoutManager.startGetReadyCountdown();
        } else {
          console.error('❌ Workout manager not initialized');
        }
      },
      
      // Complete current rep
      completeRep: () => {
        console.log('✅ Manually completing current rep');
        if (this.workoutManager.isInitialized()) {
          this.workoutManager.completeRep();
        } else {
          console.error('❌ Workout manager not initialized');
        }
      },
      
      // Force timer to done status (for testing)
      forceTimerDone: () => {
        console.log('✅ Forcing timer to done status');
        this.props.dispatch(handleTimerStatus('done'));
      },
      
      // Reset workout
      resetWorkout: () => {
        console.log('🔄 Manually resetting workout');
        if (this.workoutManager.isInitialized()) {
          this.workoutManager.resetWorkout();
        } else {
          console.error('❌ Workout manager not initialized');
        }
      },
      
      // Clear live graph data
      clearGraphData: () => {
        console.log('🧹 Clearing live graph data');
        this.state.activity.resetGraph();
      },
      
      // Get Bluetooth state
      getBluetoothState: () => {
        const globalBluetoothWrapper = GlobalBluetoothWrapper.getInstance();
        return {
          connectionState: globalBluetoothWrapper.getConnectionState(),
          calibrationState: globalBluetoothWrapper.getCalibrationState()
        };
      },
      
      // Get workout data info
      getWorkoutData: () => {
        return {
          hasActivity: !!this.state.activity,
          hasWorkout: !!this.state.activity?.workout,
          hasContent: !!this.state.activity?.workout?.content,
          hasReps: !!this.state.activity?.workout?.content?.reps,
          repsLength: this.state.activity?.workout?.content?.reps?.length || 0,
          firstRep: this.state.activity?.workout?.content?.reps?.[0],
          workoutData: this.state.activity?.workout
        };
      },
      
      // Print full debug info
      printDebugInfo: () => {
        const globalBluetoothWrapper = GlobalBluetoothWrapper.getInstance();
        console.log('🔍 === WORKOUT DEBUG INFO ===');
        console.log('Activity Status:', this.props.activityStatus);
        console.log('Timer Status:', this.props.timerStatus);
        console.log('Bluetooth Connected:', this.state.bluetoothConnected);
        console.log('Bluetooth Calibrated:', this.state.bluetoothCalibrated);
        console.log('Workout Manager State:', this.workoutManager.getState());
        console.log('Current Rep:', this.workoutManager.getCurrentRep());
        console.log('Guideline Rep:', this.state.guidelineRep);
        console.log('Next Guideline Rep:', this.state.nextGuidelineRep);
        console.log('Elapsed Time:', this.props.elapsedTime);
        console.log('Live Graph Data:', this.state.activity.liveGraphData);
        console.log('Live Graph Data Array Length:', this.state.activity.liveGraphDataArray.length);
        console.log('Workout Manager Initialized:', this.workoutManager.isInitialized());
        console.log('Bluetooth State:', {
          connectionState: globalBluetoothWrapper.getConnectionState(),
          calibrationState: globalBluetoothWrapper.getCalibrationState()
        });
        console.log('================================');
      }
    };
    // #region Bind methods to context
    this.nextStep = this.nextStep.bind(this);
    this.nextGuidelineRep = this.nextGuidelineRep.bind(this);
    this.startActivity = this.startActivity.bind(this);
    this.pauseActivity = this.pauseActivity.bind(this);
    this.restartActivity = this.restartActivity.bind(this);
    this.finishActivity = this.finishActivity.bind(this);
    this.updateTime = this.updateTime.bind(this);
    this.updateStrength = this.updateStrength.bind(this);
    this.calibrate = this.calibrate.bind(this);
    this.fetchUserStats = this.fetchUserStats.bind(this);
    this.resetExerciseState = this.resetExerciseState.bind(this);
    this.getDetailJsonWorkout = this.getDetailJsonWorkout.bind(this);
    // #endregion
  }

  // #endregion

  // #region Workout Management
  /**
   * Debug function to check current state
   */
  private debugState() {
    console.log('🔍 Current State:', {
      bluetoothConnected: this.state.bluetoothConnected,
      bluetoothCalibrated: this.state.bluetoothCalibrated,
      activityStatus: this.props.activityStatus,
      workoutManagerInitialized: this.workoutManager.isInitialized(),
      workoutDataReady: !!this.props.location.state?.workout?.content?.reps
    });
  }

  /**
   * Manual fix for stuck activityStatus - call this in console if needed
   */
  public fixActivityStatus() {
    if (this.state.bluetoothConnected && this.state.bluetoothCalibrated && this.props.activityStatus === 'calibrate') {
      console.log('🔧 Manual fix: Setting activityStatus to wait start');
      this.props.dispatch(handleActivityStatus('wait start'));
    } else {
      console.log('🔧 Manual fix: Conditions not met for fix');
      this.debugState();
    }
  }

  /**
   * Manual start workout - call this in console if stuck at wait start
   */
  public manualStartWorkout() {
    if (this.props.activityStatus === 'wait start' && this.workoutManager.isInitialized()) {
      console.log('🚀 Manual start: Starting workout');
      this.startActivity();
    } else {
      console.log('🚀 Manual start: Conditions not met');
      this.debugState();
    }
  }

  /**
   * Initialize the workout manager with current configuration
   */
  private initializeWorkoutManager() {
    // Check if workout data is available in the activity state (after getDetailJsonWorkout loads it)
    const hasWorkoutData = this.state.activity?.workout?.content?.reps && this.state.activity.workout.content.reps.length > 0;
    
    if (!hasWorkoutData) {
      console.log('ExerciseManager: Workout data not ready, skipping workout manager initialization', {
        hasActivity: !!this.state.activity,
        hasWorkout: !!this.state.activity?.workout,
        hasContent: !!this.state.activity?.workout?.content,
        hasReps: !!this.state.activity?.workout?.content?.reps,
        repsLength: this.state.activity?.workout?.content?.reps?.length || 0
      });
      return;
    }

    console.log('🚀 Initializing workout manager with config:', {
      bluetoothConnected: this.state.bluetoothConnected,
      bluetoothCalibrated: this.state.bluetoothCalibrated,
      isBluetoothReady: this.state.bluetoothConnected && this.state.bluetoothCalibrated,
      hasWorkout: !!this.state.activity.workout,
      hasReps: !!this.state.activity.workout.content.reps,
      repsCount: this.state.activity.workout.content.reps.length
    });

    this.workoutManager.initialize({
      workout: this.state.activity.workout, // Use the activity's workout data, not props
      userWeight: this.state.activity.userWeight || 0,
      addedWeights: this.state.activity.addedWeights || 0,
      bluetoothConnected: this.state.bluetoothConnected,
      bluetoothCalibrated: this.state.bluetoothCalibrated,
    }, this.props.dispatch);
    
    // Auto-start workout if Bluetooth is ready
    if (this.state.bluetoothConnected && this.state.bluetoothCalibrated) {
      console.log('🚀 Auto-starting workout - Bluetooth is ready');
      setTimeout(() => {
        this.workoutManager.startWorkout();
      }, 500); // Small delay to ensure initialization is complete
    }
  }

  /**
   * Update workout manager configuration when Bluetooth status changes
   */
  private updateWorkoutManagerConfig() {
    this.workoutManager.updateConfig({
      userWeight: this.state.activity.userWeight || 0,
      addedWeights: this.state.activity.addedWeights || 0,
      bluetoothConnected: this.state.bluetoothConnected,
      bluetoothCalibrated: this.state.bluetoothCalibrated,
    });
  }
  // #endregion

  // #region Life cycle methods
  async componentDidMount() {
    this.props.dispatch(hideSideBar());
    this.props.dispatch(handleBluetoothState('off'));
    this.props.dispatch(bluetoothConnection(false));
    // Don't set activityStatus to 'stop' - let the workout manager handle initial state
    sensorDataAnalysis.freeDataArray();
    sensorDataAnalysis.resetTimer(); // Ensure stale timer date from a previous session doesn't leak in
    window.addEventListener('resize', this.resize.bind(this));
    this.resize();
    
    // Check if global Bluetooth is connected and calibrated
    const globalBluetoothWrapper = GlobalBluetoothWrapper.getInstance();
    const connectionState = globalBluetoothWrapper.getConnectionState();
    const calibrationState = globalBluetoothWrapper.getCalibrationState();
    console.log('ExerciseManager: componentDidMount - connection state:', connectionState);
    console.log('ExerciseManager: componentDidMount - calibration state:', calibrationState);
    
    // Always require a new calibration when starting an exercise
    console.log('ExerciseManager: Requiring fresh calibration for new exercise');
    globalBluetoothWrapper.resetCalibration();
    
    // Update Bluetooth connection status (but not calibration - it's reset)
    this.setState({
      bluetoothConnected: connectionState.isConnected,
      bluetoothCalibrated: false, // Always start with no calibration
    });
    // Request wake lock to keep screen on during workout
    if ('wakeLock' in navigator) {
      try {
        (navigator as any).wakeLock.request('screen').catch(() => {});
      } catch (error) {
        // Wake lock not available or denied — non-fatal
      }
    }
    // Don't initialize workout manager here - wait for workout data to load
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize.bind(this));
    if (this.unsubscribeDataStream) {
      this.unsubscribeDataStream();
      this.unsubscribeDataStream = null;
    }
    this.workoutManager.teardown();
  }

  componentDidUpdate(prevProps) {
    // Debug: Track activityStatus changes
    if (this.props.activityStatus !== prevProps.activityStatus) {
      console.log('🔄 ActivityStatus changed:', {
        from: prevProps.activityStatus,
        to: this.props.activityStatus,
        timestamp: new Date().toISOString(),
        workoutManagerState: this.workoutManager.getState(),
        bluetoothConnected: this.state.bluetoothConnected,
        bluetoothCalibrated: this.state.bluetoothCalibrated
      });
    }
    
    // Debug: Track timer status changes
    if (this.props.timerStatus !== prevProps.timerStatus) {
      console.log('⏱️ TimerStatus changed:', {
        from: prevProps.timerStatus,
        to: this.props.timerStatus,
        timestamp: new Date().toISOString(),
        elapsedTime: this.props.elapsedTime
      });
      
      // Reset elapsed time when timer resets
      if (this.props.timerStatus === 'reset') {
        console.log('🔄 Timer reset detected, resetting elapsed time');
        this.props.dispatch(updateElapsedTime(0));
      }
    }

    // Handle timer completion - this is the main trigger for rep progression
    // Timer.tsx is the sole authority for dispatching timerStatus='done' (componentDidUpdate line 70).
    if (this.props.timerStatus === 'done' && prevProps.timerStatus !== 'done' && prevProps.timerStatus !== 'pause') {
      console.log('ExerciseManager: Timer completed - processing rep progression');
      
      // Only process if workout manager is initialized
      if (this.workoutManager.isInitialized()) {
        const activityStatus = this.props.activityStatus;

        if (activityStatus === 'hang') {
          // Hang timer expired — clear the graph and enter wait_release.
          // updateIntervals() is intentionally NOT called here: activity.currentRepIndex has
          // not yet advanced, so updateIntervals() would incorrectly re-open an interval for
          // the same rep. It is called in updateStrength()'s wait_release handler after
          // completeRep() has advanced the index.
          this.state.activity.liveGraphDataArray = [];
          this.props.dispatch(clearChartData());
          this.workoutManager.startWaitRelease();
        } else if (activityStatus === 'rest') {
          // Rest timer expired — call completeRep() to advance to the next rep.
          // completeRep() dispatches 'wait hang' (not a timer start) when the next rep is a
          // hang, so the user must pull before the hang timer begins.
          this.workoutManager.completeRep();

          this.setState(({ activity }) => {
            activity.currentRepIndex = this.workoutManager.getState().currentRepIndex;
            activity.currentRep = this.workoutManager.getCurrentRep() || activity.currentRep;
            activity.calculateExpectedStrength();
            activity.liveGraphDataArray = [];
            return { activity };
          }, () => {
            // currentRepIndex is now the next rep — safe to call updateIntervals().
            this.state.activity.updateIntervals();
            this.props.dispatch(handleCurrentRepUpdate(this.state.activity.currentRep));
            this.props.dispatch(clearChartData());
          });
          this.nextGuidelineRep();
        } else {
          // Fallback for any other timed phase
          this.workoutManager.completeRep();

          this.setState(({ activity }) => {
            activity.currentRepIndex = this.workoutManager.getState().currentRepIndex;
            activity.currentRep = this.workoutManager.getCurrentRep() || activity.currentRep;
            activity.calculateExpectedStrength();
            activity.liveGraphDataArray = [];
            return { activity };
          }, () => {
            this.state.activity.updateIntervals();
            this.props.dispatch(handleCurrentRepUpdate(this.state.activity.currentRep));
            this.props.dispatch(clearChartData());
          });
          this.nextGuidelineRep();
        }
      } else {
        console.warn('ExerciseManager: Workout manager not initialized, cannot process rep progression');
      }
    }

    // Handle activity status changes for audio and UI updates
    if (this.props.activityStatus !== prevProps.activityStatus) {
      switch (this.props.activityStatus) {
        case 'start':
          console.log('ExerciseManager: Activity started');
          sensorDataAnalysis.onStart();
          if (this.workoutManager.isInitialized()) {
            this.workoutManager.startWorkout();
          }
          break;
        case 'get ready':
          console.log('ExerciseManager: Get ready phase started');
          this.state.activity.resetGraph();
          // Clear sensor data context data points for fresh start
          if (this.workoutManager.isInitialized()) {
            this.workoutManager.startGetReadyCountdown();
          }
          break;
        case 'wait rest':
          this.audioRest.play();
          break;
        case 'wait start':
          this.state.activity.resetGraph();
          // SimpleWorkoutManager handles the full progression from here:
          // 'wait start' → startWorkout() (500ms auto-start) → 'get ready' → startGetReadyCountdown() → startRep() → 'hang'/'rest'
          break;
        case 'wait hang':
          this.audioHang.play();
          // If the user is already pulling when we enter wait_hang (e.g., they were
          // testing the hold during rest), require them to fully unload first.
          this.needsLoadBeforePull = typeof this.pulledWeight1 === 'number' && this.pulledWeight1 > 0.5;
          this.waitReleaseStartTime = null;
          this.setState({ repFeedback: null });
          // Zero bookmark: marks the rest-end boundary in the sensor data array
          sensorDataAnalysis.addDataToString(0);
          break;
        case 'wait release':
          this.waitReleaseStartTime = Date.now();
          // Note: zero bookmark is added AFTER the athlete releases (in updateStrength wait_release handler)
          // Evaluate the rep and provide audio+visual feedback
          {
            const feedback = this.evaluateRep();
            this.playRepFeedbackTone(feedback);
            this.setState({ repFeedback: feedback });
          }
          break;
        case 'hang':
          this.setState({ repFeedback: null });
          this.repStartWallTime = Date.now();
          this.chartPointBuffer = [];
          // Clear graph data when entering a new hang rep from any non-hang phase
          if (prevProps.activityStatus === 'get ready' || prevProps.activityStatus === 'wait hang' ||
              prevProps.activityStatus === 'wait rest' || prevProps.activityStatus === 'wait start' ||
              prevProps.activityStatus === 'rest') {
            this.state.activity.resetGraph();
            this.props.dispatch(clearChartData());

            // Initialize the sensor data timer exactly once — at the very first hang of the workout.
            // onStart() resets _weightDataArray and starts the elapsed-time clock.
            // Subsequent reps leave the accumulated array intact so all hang data is contiguous.
            if (sensorDataAnalysis.date === null) {
              sensorDataAnalysis.onStart();
            }

            // Set intervalStart for the first hang rep only.
            // Subsequent reps have intervalStart managed by updateIntervals() at rep boundaries.
            if (this.state.activity.intervalStart === null) {
              const firstRep = this.state.activity.workout.getRepByIndex(this.state.activity.currentRepIndex);
              if (firstRep && firstRep.intensity !== 0) {
                // After onStart() the array is empty (length 0); first data point will land at index 0.
                this.state.activity.intervalStart = Math.max(0, sensorDataAnalysis._weightDataArray.length - 1);
                console.log(`ExerciseManager: Starting first interval for rep ${this.state.activity.currentRepIndex}, start index: ${this.state.activity.intervalStart}`);
              }
            }
          }
          break;
        case 'rest':
          // Clear graph data when starting a new rep
          if (prevProps.activityStatus === 'get ready' || prevProps.activityStatus === 'wait hang' || prevProps.activityStatus === 'wait rest') {
            this.state.activity.resetGraph();
          }
          break;
        case 'reset':
          console.log('ExerciseManager: Activity reset');
          if (this.workoutManager.isInitialized()) {
            this.workoutManager.resetWorkout();
          }
          if(!this.state.done) this.setState({ done: true });
          break;
        default:
          break;
      }
    }

    // Handle calibration status changes
    if (this.props.calibrationStatus !== prevProps.calibrationStatus) {
      if(this.props.calibrationStatus === 'request'){
        this.setState({calibrationData: [], calibrateReady: false});
      }
    }
    
    // Check if global Bluetooth calibration state changed
    const globalBluetoothWrapper = GlobalBluetoothWrapper.getInstance();
    const connectionState = globalBluetoothWrapper.getConnectionState();
    const calibrationState = globalBluetoothWrapper.getCalibrationState();
    
    if (!this.isUpdatingBluetoothState) {
      this.isUpdatingBluetoothState = true;
      
      // Only update state if the values have actually changed to prevent infinite loops
      if (this.state.bluetoothConnected !== connectionState.isConnected || 
          this.state.bluetoothCalibrated !== calibrationState.isCalibrated) {
        
        const wasConnected = this.state.bluetoothConnected;
        const isNowConnected = connectionState.isConnected;
        const wasCalibrated = this.state.bluetoothCalibrated;
        const isNowCalibrated = calibrationState.isCalibrated;
        
        this.setState({
          bluetoothConnected: connectionState.isConnected,
          bluetoothCalibrated: calibrationState.isCalibrated,
        }, () => {
          this.isUpdatingBluetoothState = false;
          
          // Update workout manager with new Bluetooth state
          this.updateWorkoutManagerConfig();
          
          // If workout manager is not initialized yet but Bluetooth is now ready, try to initialize it
          if (!this.workoutManager.isInitialized() && isNowConnected && this.state.bluetoothCalibrated) {
            console.log('ExerciseManager: Bluetooth became ready, attempting to initialize workout manager');
            this.initializeWorkoutManager();
          }
          
          // If Bluetooth just became calibrated and we're still in calibrate status, update to wait start
          if (!wasCalibrated && isNowCalibrated && this.props.activityStatus === 'calibrate') {
            console.log('ExerciseManager: Bluetooth became calibrated, updating activity status to wait start');
            this.props.dispatch(handleActivityStatus('wait start'));
          }
          
          // Handle disconnection: pause workout and show reconnection prompt
          if (wasConnected && !isNowConnected) {
            console.log('ExerciseManager: Bluetooth disconnected during workout - pausing activity');
            this.handleBluetoothDisconnection();
          }
          
          // Handle reconnection: dismiss notification and potentially resume workout
          if (!wasConnected && isNowConnected) {
            console.log('ExerciseManager: Bluetooth reconnected');
            this.handleBluetoothReconnection();
          }
        });
      } else {
        this.isUpdatingBluetoothState = false;
      }
    }
    
    // Subscribe to the data stream once calibration is complete.
    // addDataCallback fans out to all subscribers, so SensorDataContext keeps working too.
    if (calibrationState.isCalibrated && !this.unsubscribeDataStream) {
      console.log('ExerciseManager: Subscribing to data stream...');
      this.unsubscribeDataStream = globalBluetoothWrapper.addDataCallback((data) => {
        this.updateStrength(data, 0);
      });
      // Ensure notifications are actually running (idempotent if already started)
      globalBluetoothWrapper.ensureDataStreamActive(() => {}).catch((error) => {
        console.error('ExerciseManager: Failed to start data stream:', error);
      });
      console.log('ExerciseManager: Subscribed to data stream');
    }
  }

  // #endregion
  resize() {
    this.setState({ mobile: window.innerWidth <= 760 });
    this.setState({ landscape: window.innerWidth > window.innerHeight });
  }

  handleChange() {
    const self = this; // Store `this` component outside the callback
    if ('onorientationchange' in window) {
      window.addEventListener('orientationchange', () => {
        // `this` is now pointing to `window`, not the component. So use `self`.
        self.setState({
          orientation: !self.state.orientation,
        });
      }, false);
    }
  }

  getDetailJsonWorkout() {
    const requestURL = '/v1/workoutWeb/getJsonDetailedWorkout';
    api()
      .get(requestURL, { params: { id: this.props.location.state.workout.id, type: this.props.location.state.workout.type } })
      .then((response) => {
        this.setState(({ activity, guidelineRep }) => {
          activity.workout.content = { 
            reps: response.data.reps,
            repNb: response.data.reps.length,
            duration: 0,
            difficulty: 0,
            hangboard: '',
            type: ''
          };
          activity.currentRep = activity.workout.content.reps[0];
          guidelineRep = activity.currentRep;
          activity.calculateExpectedStrength();
          // const firstRep= activity.workout.getRepByIndex(activity.currentRepIndex);
          // this.props.dispatch(handleCurrentRepUpdate(firstRep));
          return { activity, guidelineRep };
        }, () => {
          // Update the current rep after state is set
          this.props.dispatch(handleCurrentRepUpdate(this.state.activity.currentRep));
          
          // Initialize workout manager now that workout data is loaded
          console.log('ExerciseManager: About to initialize workout manager, current activityStatus:', this.props.activityStatus);
          console.log('ExerciseManager: Current Bluetooth state:', {
            bluetoothConnected: this.state.bluetoothConnected,
            bluetoothCalibrated: this.state.bluetoothCalibrated
          });
          this.initializeWorkoutManager();
        });
      });
  }

  fetchUserStats() {
    const requestURL = '/v1/athlete/getStrength';
    api()
      .get(requestURL)
      .then((response) => {
        this.setState(({ activity }) => {
          activity.setUserStrength(response.data);
          return { activity };
        }, () => { this.props.dispatch(handleCurrentRepUpdate(this.state.activity.currentRep)); });
      })
      .catch(() => {
        this.setState(({ activity }) => {
          activity.setUserStrength(1);
          return { activity };
        }, () => { this.props.dispatch(handleCurrentRepUpdate(this.state.activity.currentRep)); });
      });
  }

  // #region Updates rep
  nextStep() {
    this.setState(({ activity }) => {
      activity.updateIntervals();
      activity.updateCurrentRep();
      return { activity };
    }, () => {
      sensorDataAnalysis.addDataToString(0);
      this.props.dispatch(handleActivityStatus(this.state.activity.currentRep.intensity === 0 ? 'rest' : 'hang'));
      this.props.dispatch(handleTimerStatus('reset'));
      this.props.dispatch(handleCurrentRepUpdate(this.state.activity.currentRep));
    });
  }

  nextGuidelineRep() {
    // Use workout manager's current rep index for consistency
    const currentRepIndex = this.workoutManager.isInitialized() ? 
      this.workoutManager.getState().currentRepIndex : this.state.activity.currentRepIndex;
    
    const currentRep = this.workoutManager.isInitialized() ? 
      this.workoutManager.getCurrentRep() : this.state.activity.currentRep;
    
    const nextIndex = currentRepIndex + 1;
    const nextRep = this.state.activity.workout.getRepByIndex(nextIndex);
    
    if (isUndefined(nextRep)) {
      // No more reps available
      this.setState({ guidelineRep: currentRep, nextGuidelineRep: null });
    } else if (isUndefined(this.state.activity.workout.getRepByIndex(nextIndex + 1))) {
      this.setState({ guidelineRep: nextRep, nextGuidelineRep: null });
    } else {
      const secondNextRep = this.state.activity.workout.getRepByIndex(nextIndex + 1);
      this.setState({ guidelineRep: nextRep, nextGuidelineRep: secondNextRep });
    }
  }
  // #endregion

  // #region Activity states methods
  startActivity() {
    if (this.workoutManager.isInitialized()) {
      const phase = this.workoutManager.getState().phase;
      if (phase === 'paused') {
        this.workoutManager.resumeWorkout();
      } else {
        this.workoutManager.startWorkout();
      }
    }
    this.setState(({ activity }) => {
      activity.start();
      return { activity };
    });
  }

  pauseActivity() {
    if (this.workoutManager.isInitialized()) {
      this.workoutManager.pauseWorkout();
    }
    this.setState(({ activity }, props) => {
      activity.pause(props.activityStatus);
      return { activity };
    });
  }

  restartActivity() {
    if (this.workoutManager.isInitialized()) {
      this.workoutManager.resetWorkout();
    }
    this.resetExerciseState();
    sensorDataAnalysis.freeDataArray();
    this.globalBluetoothWrapper.stopDataStream();
  }

  async finishActivity() {
    console.log('ExerciseManager: finishActivity called');
    this.props.dispatch(handleTimerStatus('stop'));
    
    console.log('ExerciseManager: Checking sensor data array length:', sensorDataAnalysis._weightDataArray.length);
    console.log('ExerciseManager: Sensor data array (first 10):', sensorDataAnalysis._weightDataArray.slice(0, 10));
    console.log('ExerciseManager: Sensor data array (last 10):', sensorDataAnalysis._weightDataArray.slice(-10));
    console.log('ExerciseManager: Activity intervals collected:', this.state.activity.intervals.length);
    console.log('ExerciseManager: Activity intervals:', this.state.activity.intervals);
    
    if (sensorDataAnalysis._weightDataArray.length > 0) {
      // finish() FIRST — it reads activity.intervals and calls activity.reset() internally.
      // resetExerciseState() also calls activity.reset() which would wipe intervals if called first.
      const archive = await this.state.activity.finish();
      console.log('ExerciseManager: Archive data being sent to backend:', archive);
      this.resetExerciseState();
      // @ts-ignore
      this.props.dispatch(uploadActivity(archive)).then((uploadedId: number) => {
        console.log('ExerciseManager: Activity uploaded with ID:', uploadedId);
        this.props.history.push(`/activities/${uploadedId}`);
      }).catch((error: any) => {
        console.error('ExerciseManager: Failed to upload activity:', error);
        if (error.response && error.response.data) {
          console.error('ExerciseManager: Backend error:', error.response.data);
          if (error.response.data.error) {
            console.error('ExerciseManager: Error message:', error.response.data.error);
          }
        }
        this.props.history.push('/');
      });
    } else {
      console.log('ExerciseManager: No sensor data available, cannot save activity');
      this.resetExerciseState();
      this.props.history.push('/');
    }
  }

  resetExerciseState() {
    this.setState(({ activity }) => {
      activity.reset();
      return {
        activity,
        guidelineRep: activity.workout.getRepByIndex(0),
      };
    });
    this.props.dispatch(handleBluetoothState("off"));
    this.props.dispatch(bluetoothConnection(false)); // Reset Bluetooth connection state
    this.props.dispatch(handleActivityStatus('reset'));
    this.props.dispatch(handleCurrentRepUpdate(this.state.activity.currentRep));
    this.props.dispatch(handleTimerStatus('stop'));
    this.props.dispatch(handleCalibrationStatus('stop'));
    this.props.dispatch(showSideBar());
  }

  // Handle Bluetooth disconnection during workout
  handleBluetoothDisconnection() {
    // Only pause if we're currently in an active workout state
    const activeStates = ['hang', 'rest', 'working', 'wait hang', 'wait rest', 'wait start', 'wait release'];
    if (activeStates.includes(this.props.activityStatus)) {
      console.log('ExerciseManager: Pausing workout due to Bluetooth disconnection');
      
      // Pause the activity
      this.props.dispatch(handleActivityStatus('pause'));
      this.props.dispatch(handleTimerStatus('pause'));
      
      // Update activity state
      this.setState(({ activity }, props) => {
        activity.pause(props.activityStatus);
        return { activity };
      });
      
      // Show disconnection notification
      this.setState({ showDisconnectionNotification: true });
      
      console.log('ExerciseManager: Workout paused - please reconnect Bluetooth device');
    }
  }

  // Dismiss disconnection notification
  dismissDisconnectionNotification = () => {
    this.setState({ showDisconnectionNotification: false });
  };

  // Handle Bluetooth reconnection
  handleBluetoothReconnection() {
    // Dismiss any disconnection notification
    this.setState({ showDisconnectionNotification: false });
    
    // If we were paused due to disconnection, we can potentially resume
    // But we need to wait for calibration first
    console.log('ExerciseManager: Bluetooth reconnected - waiting for calibration');
  }
  // #endregion

  // #region Updates child components data
  updateTime(time: number) {
    const { activityStatus } = this.props;
    const paused = this.state.activity.paused;

    if (!paused) {
      // Use the synchronously-updated instance variable (same source as the on-screen display)
      // instead of this.props.currentStrength (Redux state, one render cycle behind).
      let strength: number | string = this.pulledWeight1;
      if (typeof strength === 'string') {
        strength = (strength === 'Out' || strength === 'MAX') ? 0 : parseFloat(strength) || 0;
      }
      if (typeof strength !== 'number') {
        strength = 0;
      }
      const numStrength = strength as number;

      this.setState(({ activity }) => {
        activity.updateLiveGraphData(time, numStrength);
        return { activity };
      });
    }
    // Keep Redux in sync — Timer.tsx manages per-rep elapsed time (resets to 0 on timerStatus='reset').
    // TimerService writes to globalTimer.elapsedTime (separate slice) so there is no collision.
    // By removing setState({ elapsedTime: time }), we eliminate the dual-render flicker path.
    this.props.dispatch(updateElapsedTime(time));
  }



  updateStrength(sensorData: any, time) {
    // Always read calibration data from GlobalBluetoothWrapper — it's the single source of
    // truth and is set immediately after calibration, before activity.userWeight is updated
    // via the setState callback in calibrate(). Falling back to activity keeps backwards
    // compatibility if the wrapper hasn't calibrated yet.
    const calibrationState = this.globalBluetoothWrapper.getCalibrationState();
    const userWeight = calibrationState.userWeight || this.state.activity.userWeight || 0;
    const addedWeights = calibrationState.addedWeights || this.state.activity.addedWeights || 0;

    // The Entralpi device is a floor-plate sensor: sensor reading decreases as the user pulls
    // weight onto the hangboard above. pulledForce = userWeight + addedWeights - sensorReading.
    const measuredForce = typeof sensorData === 'string' ? parseFloat(sensorData) || 0 : sensorData;
    const forceResult = calculateForce({
      measuredForce,
      userWeight,
      addedWeights,
      mode: ForceCalculationMode.LIFTED_FORCE
    });

    // Round to 0.1 kg — keeps stored/displayed values clean without losing meaningful precision
    this.pulledWeight1 = Math.round((forceResult.value as number) * 10) / 10;
    const status = this.props.activityStatus;
    const now = Date.now();

    // ─── PATH 1: full-rate sensor recording + chart buffering ──────────────────
    // Runs on every BLE tick with zero Redux dispatches — main thread stays free.
    // _weightDataArray receives every point the device sends (up to 100 Hz).
    // Chart points are buffered here and flushed as a batch in Path 2.
    if (status === 'hang') {
      sensorDataAnalysis.addDataToString(this.pulledWeight1);
      if (this.pulledWeight1 > 0) {
        const repElapsed = this.repStartWallTime > 0 ? (now - this.repStartWallTime) / 1000 : 0;
        this.chartPointBuffer.push({ x: repElapsed, y: this.pulledWeight1 });
      }
    } else if (status === 'wait hang' && this.workoutManager.getState().repPhase === 'wait_hang') {
      // Capture approach-to-pull data at full rate
      sensorDataAnalysis.addDataToString(this.pulledWeight1);
    } else if (status === 'wait release' && this.workoutManager.getState().repPhase === 'wait_release') {
      // Continue recording after hang timer ends until athlete releases (< 3 kg)
      sensorDataAnalysis.addDataToString(this.pulledWeight1);
    }

    // ─── PATH 2: throttled display updates (~20 Hz) ────────────────────────────
    // One Redux dispatch per 50 ms regardless of BLE rate → ~20 React re-renders/s.
    // The chart batch may contain up to 5 real 100 Hz points per flush.
    if (now - this.lastDisplayUpdateTime >= ExerciseManager.DISPLAY_INTERVAL_MS) {
      this.lastDisplayUpdateTime = now;
      this.props.dispatch(updateCurrentStrength(this.pulledWeight1));

      // Flush chart buffer — one dispatch carries all points accumulated since last flush
      if (this.chartPointBuffer.length > 0) {
        this.props.dispatch(addChartDataPoints([...this.chartPointBuffer]));
        this.chartPointBuffer = [];
      }

      // wait_release chart (single point per flush, wall-clock x)
      if (status === 'wait release' && this.waitReleaseStartTime !== null && this.pulledWeight1 > 0) {
        const x = (this.props.currentRep?.time || 0) + (now - this.waitReleaseStartTime) / 1000;
        this.props.dispatch(addChartDataPoint({ x, y: this.pulledWeight1 }));
      }
    }

    // ─── PATH 3: state machine ─────────────────────────────────────────────────
    // Pull/release detection always runs — comparisons only, no dispatches.
    switch (status) {
      case 'calibrate':
        if (this.props.calibrationStatus === 'error') {
          this.setState({calibrationData: [sensorData]});
          this.setState({ calibrateReady: true });
        } else if (this.props.calibrationStatus === 'request') {
          this.setState(prevState => ({ calibrationData: [...prevState.calibrationData, this.pulledWeight1] }));
          if (this.state.calibrationData.length > 100)
            this.setState({ calibrateReady: true });
        }
        break;
      case 'hang':
        // Recording and display handled in paths 1 & 2 above.
        break;
      case 'rest':
      case 'working':
        break;
      case 'wait hang': {
        // Guard: startRep() changes repPhase synchronously, preventing repeat calls on
        // subsequent BLE ticks before the Redux activityStatus prop updates.
        if (this.workoutManager.getState().repPhase !== 'wait_hang') break;

        if (this.needsLoadBeforePull) {
          // Wait for user to fully unload before detecting a pull
          if (this.pulledWeight1 < 0.5) this.needsLoadBeforePull = false;
        } else {
          const currentRep = this.workoutManager.getCurrentRep();
          const pullThreshold = currentRep?.expectedStrength ? currentRep.expectedStrength * 0.2 : 2;
          if (this.pulledWeight1 > pullThreshold) this.workoutManager.startRep();
        }
        break;
      }
      case 'wait release': {
        // Guard: completeRep() changes repPhase synchronously.
        if (this.workoutManager.getState().repPhase !== 'wait_release') break;

        if (this.pulledWeight1 < 0.5) {
          // Zero bookmark: marks the rep-end boundary now that the athlete has fully released
          sensorDataAnalysis.addDataToString(0);
          // User has let go — advance to the next rep
          this.workoutManager.completeRep();
          this.setState(({ activity }) => {
            activity.currentRepIndex = this.workoutManager.getState().currentRepIndex;
            activity.currentRep = this.workoutManager.getCurrentRep() || activity.currentRep;
            activity.calculateExpectedStrength();
            activity.liveGraphDataArray = [];
            return { activity };
          }, () => {
            this.state.activity.updateIntervals();
            this.props.dispatch(handleCurrentRepUpdate(this.state.activity.currentRep));
          });
          this.nextGuidelineRep();
        }
        break;
      }
      case 'wait rest':
        break;
      case 'wait start':
        break;
      default:
        break;
    }
  }

  private evaluateRep(): 'success' | 'fail' | 'too_much' {
    // Combine Redux points with anything still in the local buffer to ensure
    // we have the full rep data even if the last throttled flush hasn't happened.
    const reduxPoints = this.props.chartDataArray || [];
    const points = [...reduxPoints, ...this.chartPointBuffer];
    
    // Fallback logic for expected strength: prioritize Redux, but check local Activity if Redux is 0.
    let expected = this.props.currentRep?.expectedStrength || 0;
    if (expected === 0 && this.state.activity.currentRep.expectedStrength > 0) {
      console.log('ExerciseManager: Falling back to local activity for expectedStrength');
      expected = this.state.activity.currentRep.expectedStrength;
    }

    const isHang = this.props.currentRep?.intensity > 0;
    
    console.log('ExerciseManager: evaluateRep', {
      pointsCount: points.length,
      expectedStrength: expected,
      isHang,
      intensity: this.props.currentRep?.intensity
    });

    if (expected === 0 && isHang) {
      console.warn('ExerciseManager: expectedStrength is 0 for a hang rep!');
      // If we literally have no target but it's a hang, we can't evaluate correctly.
      // Defaulting to success is safer for UX than persistent failure if calculation failed.
      return 'success';
    }

    if (points.length === 0) {
      return isHang ? 'fail' : 'success';
    }

    if (expected === 0) return 'success'; // Rest rep or absolute zero intensity

    const lower = expected * 0.8;
    const upper = expected * 1.2;
    const onTarget = points.filter(p => p.y >= lower && p.y <= upper).length;
    const tooHigh = points.filter(p => p.y > upper).length;
    const total = points.length;

    console.log('ExerciseManager: evaluation stats', {
      onTarget,
      tooHigh,
      total,
      ratio: onTarget / total
    });

    if (onTarget / total >= 0.5) return 'success';
    if (tooHigh / total > 0.5) return 'too_much';
    return 'fail';
  }

  private playRepFeedbackTone(result: 'success' | 'fail' | 'too_much') {
    try {
      const ctx = new ((window as any).AudioContext || (window as any).webkitAudioContext)();
      const play = (freq: number, start: number, duration: number) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.frequency.value = freq;
        gain.gain.setValueAtTime(0.3, ctx.currentTime + start);
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + start + duration);
        osc.start(ctx.currentTime + start);
        osc.stop(ctx.currentTime + start + duration);
      };
      if (result === 'success') { play(523, 0, 0.15); play(659, 0.18, 0.25); }
      if (result === 'fail') { play(440, 0, 0.15); play(330, 0.18, 0.25); }
      if (result === 'too_much') { play(587, 0, 0.1); play(587, 0.13, 0.1); play(587, 0.26, 0.1); }
    } catch (_) { /* audio not supported */ }
  }

  // #region Calibration
  calibrate(userWeight: number, addedWeights: number) {
    console.log('ExerciseManager: calibrate called with:', { userWeight, addedWeights });
    this.setState(({ activity }) => {
      activity.userWeight = userWeight;
      activity.addedWeights = addedWeights;
      activity.calculateAllExpectedStrengths();
      return { activity };
    }, () => {
      // PROMPT SYNC: Ensure Redux currentRep is updated with calculated expectedStrength values
      // immediately after calibration so that evaluateRep doesn't see 0.
      this.props.dispatch(handleCurrentRepUpdate(this.state.activity.currentRep));
    });
    
    // Update the GlobalBluetoothWrapper with the calibration data
    this.globalBluetoothWrapper.updateCalibrationData(userWeight, addedWeights);
    
    // Also update the Bluetooth calibration state
    this.setState({
      bluetoothCalibrated: true
    }, () => {
      console.log('🔧 Calibration state updated in ExerciseManager:', {
        bluetoothConnected: this.state.bluetoothConnected,
        bluetoothCalibrated: this.state.bluetoothCalibrated,
        currentActivityStatus: this.props.activityStatus
      });
      // Update workout manager with new calibration data
      this.updateWorkoutManagerConfig();
      
      // If workout manager is not initialized yet, initialize it now that calibration is complete
      if (!this.workoutManager.isInitialized()) {
        console.log('🎯 Calibration completed - initializing workout manager');
        this.initializeWorkoutManager();
        
        // Force update activity status after a short delay to ensure initialization completes
        setTimeout(() => {
          if (this.state.bluetoothConnected && this.state.bluetoothCalibrated && this.props.activityStatus === 'calibrate') {
            console.log('🔧 Force updating activity status to wait start after calibration');
            this.props.dispatch(handleActivityStatus('wait start'));
          }
        }, 100);
      } else {
        // If workout manager is already initialized, just update the activity status
        console.log('🎯 Calibration completed - updating activity status to wait start');
        this.props.dispatch(handleActivityStatus('wait start'));
      }
    });
    
    console.log('ExerciseManager: Calibration state updated:', { 
      userWeight, 
      addedWeights, 
      bluetoothCalibrated: true 
    });
  }

  exerciseNotDone() {
      const { bluetoothConnected, bluetoothCalibrated } = this.state;
      console.log('ExerciseManager: exerciseNotDone check -', { bluetoothConnected, bluetoothCalibrated });
      
      // Show Bluetooth setup flow if not connected or not calibrated
      if (!bluetoothConnected || !bluetoothCalibrated) {
        return (
          <BluetoothSetupFlowWithContext
            onReady={() => {
              console.log('ExerciseManager: Bluetooth setup flow - onReady');
              // The state updates in calibrate or connect will trigger re-render
            }}
            onCalibrationComplete={(weight, addedWeights) => {
              console.log('ExerciseManager: Bluetooth setup flow - onCalibrationComplete:', { weight, addedWeights });
              this.calibrate(weight, addedWeights);
            }}
            showReadyStep={false}
          />
        );
      }
      
      return (
        <Dimmer active={this.state.done}>
          <Loader style={{ display: 'block' }}>Loading</Loader>
          <Calibration callback={this.calibrate} sensorData={this.state.calibrationData} ready= {this.state.calibrateReady}/>
        </Dimmer>
      );
  }
  // #endregion

  mobileDisplay() {
    if (this.state.landscape)
      return this.mobileLandscapeDisplay();
    else
      return this.portraitDisplay();
  }

  portraitDisplay() {
    return (
      <>
        <Grid className="exerciseManager-container">
          <Grid.Row className="exMa-first-row">
            <i className="pause icon finishExercise" onClick={this.pauseActivity} />
            <GlobalTimer />
          </Grid.Row>
          <Grid.Row className="exMa-second-row">
            <Grid.Column className="guidelinesContainer" width={13}>
              <Guidelines className="guidelines" rep={this.state.guidelineRep} nextRep={this.state.nextGuidelineRep} hangboard={this.state.activity.workout.hangboard} />
            </Grid.Column>
            <Grid.Column width={3} style={{ padding: '0px' }}>
              <LiveStrengthBar pulledWeight={ this.pulledWeight1} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="exMaInfosContainer">
            <GridColumn width={6}>
              <div className="setRep">
                <ExerciseSetRep />
              </div>
            </GridColumn>
            <GridColumn width={10}>
              <div className="pulledWeight">
                <PulledWeight pulledWeight={this.pulledWeight1} />
              </div>
            </GridColumn>
          </Grid.Row>
          <Grid.Row className="timer-row">
            <Timer updateTime={this.updateTime} />
          </Grid.Row>
        </Grid>
      </>
    );
  }

  desktopDisplay() {
    return (
      <Grid className="exerciseManager-container-wide">
        <Grid.Row className="exMa-first-row">
          <div onClick={this.pauseActivity} className="pauseExercise_desktop">
            <i className="pause icon" />
            <p className="pauseText">{toUpper(this.props.t('common.pause'))}</p>
          </div>
          <GlobalTimer />
        </Grid.Row>
        <Grid.Row relaxed className="exMa-second-row">
          <Grid.Column width={8} className="guidelinesContainer_desktop">
            <Guidelines className="guidelines_desktop" rep={this.state.guidelineRep} nextRep={this.state.nextGuidelineRep} hangboard={this.state.activity.workout.hangboard} />
          </Grid.Column>
          <Grid.Column width={8} style={{ padding: '0px' }}>
            <div className="livegraph" style={{ padding: '0px' }}>
              <LiveGraphWindow />
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="exMaInfosContainer">
          <GridColumn width={4}>
            <div className="setRep">
              <ExerciseSetRep />
            </div>
          </GridColumn>
          <GridColumn width={4}>
            <div className="pulledWeight_desktop">
              <PulledWeight pulledWeight={this.pulledWeight1} />
            </div>
          </GridColumn>
          {/* <GridColumn width={8}>
          <DataTable />
        </GridColumn> */}
        </Grid.Row>
        <Grid.Row className="timer-row">
          <Timer updateTime={this.updateTime} />
        </Grid.Row>
      </Grid>
    );
  }

  mobileLandscapeDisplay() {
    return (
      <Grid className="exerciseManager-container-wide">
        <Grid.Row className="exMa-first-row">
          <div onClick={this.pauseActivity} className="pauseExercise_desktop">
            <i className="pause icon" />
            <p className="pauseText">{toUpper(this.props.t('common.pause'))}</p>
          </div>
          <GlobalTimer />
        </Grid.Row>
        <Grid.Row relaxed className="exMa-second-row">
          <Grid.Column width={8} className="guidelinesContainer_desktop">
            <Guidelines className="guidelines_desktop" rep={this.state.guidelineRep} nextRep={this.state.nextGuidelineRep} hangboard={this.state.activity.workout.hangboard} />
          </Grid.Column>
          <Grid.Column width={8} style={{ padding: '0px' }}>
            <div className="livegraph" style={{ padding: '0px' }}>
              <LiveGraphLandscape />
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="exMaInfosContainer">
          <GridColumn width={4}>
            <div className="setRep">
              <ExerciseSetRep />
            </div>
          </GridColumn>
          <GridColumn width={4}>
            <div className="pulledWeight_desktop">
              <PulledWeight pulledWeight={this.pulledWeight1} />
            </div>
          </GridColumn>
          {/* <GridColumn width={8}>
          <DataTable />
        </GridColumn> */}
        </Grid.Row>
        <Grid.Row className="timer-row">
          <Timer updateTime={this.updateTime} />
        </Grid.Row>
      </Grid>
    );
  }

  render() {
    const workoutType: 'hangboard' = 'hangboard';
    const { bluetoothConnected, bluetoothCalibrated } = this.state;
    
    return (
      <BluetoothProvider>
        <SensorDataProvider>
          <WorkoutTypeSetter workoutType={workoutType}>
            <CalibrationDataBridge 
              userWeight={this.state.activity.userWeight || 0} 
              addedWeights={this.state.activity.addedWeights || 0}
            >
              {(!bluetoothConnected || !bluetoothCalibrated) ? (
                this.exerciseNotDone()
              ) : (
                <>
                  { this.state.mobile ? this.mobileDisplay() : this.desktopDisplay()}
                  <Dimmer
                    active={this.state.activity.paused}
                    verticalAlign="center"
                  >
                    <Header as="h2" inverted>
                      Paused ?
                    </Header>

                    <Navigation
                      leftIcon="stop"
                      leftIconAction={this.finishActivity}
                      middleIcon="play"
                      middleIconAction={this.startActivity}
                      rightIcon="undo"
                      rightIconAction={this.restartActivity}
                      style={{ bottom: 'auto' }}
                    />
                  </Dimmer>
                </>
              )}
            </CalibrationDataBridge>
          </WorkoutTypeSetter>
          
          {/* Visual Timer Bar - Show during active workout phases */}
          {(() => {
            // Show VisualTimerBar when Bluetooth is connected and calibrated, and not in initial states
            const shouldShow = this.state.bluetoothConnected && this.state.bluetoothCalibrated &&
             this.props.activityStatus !== 'stop' && this.props.activityStatus !== 'reset' &&
             this.props.activityStatus !== 'calibrate';

            return shouldShow ? <VisualTimerBar /> : null;
          })()}

          {/* Full-screen cue overlay — shown during wait_hang and wait_release */}
          {this.props.activityStatus === 'wait hang' && (
            <div className="pull-cue-overlay pull-cue-overlay--pull">
              <span className="pull-cue-overlay__text">PULL!</span>
            </div>
          )}
          {this.props.activityStatus === 'wait release' && (
            <div className="pull-cue-overlay pull-cue-overlay--release">
              <span className="pull-cue-overlay__text">LET GO</span>
            </div>
          )}

          {/* Rep feedback toast — fixed at top, auto-dismisses after 3 s */}
          <RepFeedbackToast feedback={this.state.repFeedback} />
          
          {/* Bluetooth Disconnection Notification */}
          <BluetoothDisconnectionNotification
            isVisible={this.state.showDisconnectionNotification}
            onDismiss={this.dismissDisconnectionNotification}
          />
        </SensorDataProvider>
      </BluetoothProvider>
    );
  }
}

export default withTranslation('workout')(connect(mapStateToProps)(ExerciseManager));
